import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ResourceColumn, ResourceListPage } from '../../components/resource/ResourceListPage';
import { Treinamento } from '../../types/pessoas';
import { treinamentosService } from '../../services';

const columns: ResourceColumn<Treinamento>[] = [
  { header: "Operador", accessor: "operador_nome" },
  { header: "Tipo", accessor: "tipo_treinamento" },
  { header: "Realização", accessor: "data_realizacao" },
  { header: "Resultado", accessor: "resultado" },
  { header: "Validade", accessor: "validade" }
];

export const TreinamentosListPage: React.FC = () => {
  const navigate = useNavigate();

  return (
  <ResourceListPage
    title="Treinamentos"
    description="Histórico de treinamentos aplicados."
    columns={columns}
    service={treinamentosService}
    createPath="/admin/pessoas/treinamentos/novo"
      onEdit={(item) => item.id && navigate("/admin/pessoas/treinamentos/editar", { state: { record: item } })}
  />
  );
};